class UserTimesheetsController {
  constructor(JobsService, NotificationService, $scope) {
    "ngInject";
    this.JobsService = JobsService;
    this.NotificationService = NotificationService;
    this.$scope = $scope;
    this._searchTimer = null;
    this.searchJobId = '';
    this._deletedJobIds = new Set(); // track locally deleted job IDs
  }

  $onInit() {
    this._dataSource = this.JobsService.getJugglerJobsDataSource(this.userId);

    this._dataSource.bind("requestStart", () => {
      // Use Kendo's native progress over the whole component so it always shows
      kendo.ui.progress($("#timesheets-grid"), true);
    });

    this._dataSource.bind("requestEnd", () => {
      kendo.ui.progress($("#timesheets-grid"), false);
    });

    this._dataSource.bind("error", () => {
      kendo.ui.progress($("#timesheets-grid"), false);
    });

    // After every read from the API, strip out any locally-deleted jobs
    this._dataSource.bind('change', () => {
      this._removeDeletedFromDataSource();
    });

    const ctr = this;
    this.confirmDeleteDialogOptions = {
      title: 'Confirm Remove',
      visible: false,
      closable: true,
      modal: true,
      buttonLayout: 'normal',
      messages: { close: '' },
      actions: [
        { text: 'No' },
        {
          text: 'Yes',
          primary: true,
          action: () => ctr._doDelete()
        }
      ]
    };

    this.gridOptions = {
      dataSource: this._dataSource,
      sortable: true,
      pageable: true,
      resizable: true,
      noRecords: {
        template: 'No Completed One-off Jobs found.'
      },
      columns: [
        { field: 'id', title: 'Job ID', width: '100px', filterable: false, template: '#= data.id || data.jobId || data.JobId || data.Id || "" #' },
        { field: 'paymentType', title: 'Payment Type', width: '130px', filterable: false, template: '#= (data.paymentType == 1 || data.PaymentType == 1) ? "Fixed Payment" : (data.paymentType == 2 || data.PaymentType == 2) ? "Hourly Payment" : (data.paymentType || data.PaymentType || "") #' },
        { field: 'jobDate', title: 'Job Date', width: '120px', filterable: false, template: `#= (data.jobDate || data.JobDate) ? kendo.toString(new Date(data.jobDate || data.JobDate), 'dd/MM/yyyy') : "" #` },
        { field: 'price', title: 'Price ($)', width: '100px', filterable: false, template: '#= data.price || data.Price || 0 #' },
        { field: 'jobStatus', title: 'Job Status', width: '120px', filterable: false, template: 'Completed' },
        {
          command: [
            {
              text: 'Remove Timesheet',
              className: 'k-grid-deleteTimesheet',
              click: this.deleteTimesheet.bind(this)
            }
          ],
          title: 'Actions',
          width: '160px'
        },
      ]
    };
  }

  onSearchInput() {
    // Show loader as soon as user types
    this.isSearching = true;

    // Clear any existing timer on every keystroke
    if (this._searchTimer) {
      clearTimeout(this._searchTimer);
    }

    // Start a new 2-second debounce timer
    this._searchTimer = setTimeout(() => {
      // Input type="number" gives a Number, so cast to String before .trim()
      const term = String(this.searchJobId || '').trim();

      if (term === '') {
        // No search term — clear filter, show all records
        this._dataSource.filter([]);
      } else {
        const parsedTerm = parseInt(term, 10) || 0;
        // Filter where any id variant matches the typed job ID
        this._dataSource.filter({
          logic: "or",
          filters: [
            { field: 'id', operator: 'eq', value: parsedTerm },
            { field: 'jobId', operator: 'eq', value: parsedTerm },
            { field: 'JobId', operator: 'eq', value: parsedTerm },
            { field: 'Id', operator: 'eq', value: parsedTerm }
          ]
        });
      }

      this._searchTimer = null;
      this.isSearching = false;
      this.$scope.$applyAsync();
    }, 2000);
  }

  _removeDeletedFromDataSource() {
    if (this._deletedJobIds.size === 0) return;
    const ds = this._dataSource;
    const toRemove = ds.data().filter(item => {
      const id = item.id || item.jobId || item.JobId || item.Id;
      return this._deletedJobIds.has(id);
    });
    toRemove.forEach(item => ds.remove(item));
  }

  deleteTimesheet(e) {
    e.preventDefault();
    const grid = $(e.target).closest("[data-role=grid]").data("kendoGrid");
    const dataItem = grid.dataItem($(e.target).closest("tr"));
    this._pendingDeleteJobId = dataItem.id || dataItem.jobId || dataItem.JobId || dataItem.Id;
    this.confirmDeleteDialog.open();
  }

  _doDelete() {
    if (!this._pendingDeleteJobId) return;

    // Show loader over the component while the delete API is running
    this.isDeleting = true;
    this.$scope.$applyAsync();

    this.JobsService.deleteTimesheet(this._pendingDeleteJobId, () => {
      this.isDeleting = false;
      this.$scope.$applyAsync();
      this.NotificationService.success("Timesheet is removed");

      // Add to local blacklist so this job never shows again even after search
      this._deletedJobIds.add(this._pendingDeleteJobId);

      const grid = $("#timesheets-grid").data("kendoGrid");
      if (grid) {
        // Immediately remove from in-memory data so it disappears instantly
        const dataItem = grid.dataSource.get(this._pendingDeleteJobId);
        if (dataItem) {
          grid.dataSource.remove(dataItem);
        } else {
          this._removeDeletedFromDataSource();
        }
      }
      this._pendingDeleteJobId = null;
    }, (error) => {
      this.isDeleting = false;
      this.$scope.$applyAsync();
      this.NotificationService.error("Failed to remove timesheet: " + ((error && error.data) || "Unknown error"));
      this._pendingDeleteJobId = null;
    });
  }
}

export default UserTimesheetsController;




/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-timesheets/user-timesheets.controller.js
 **/